import { CSSObject } from "@emotion/react";

export const containerCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  minHeight: "120px",
  width: "100%",
};

export const containerWithoutBarGraphCss: CSSObject = {
  minHeight: "unset",
};

export const headerTextCss: CSSObject = {
  fontWeight: 700,
};

export const PercentageBarGraphContainerCss: CSSObject = {
  marginRight: "-18px",
  minWidth: "170px",
};
